module.exports = __webpack_public_path__ + "static/Interlocutory Applications-b8a6b3fa79fcf83de2138a5490036aea.jpg";